import { render, staticRenderFns } from "./ProfilePosts.vue?vue&type=template&id=cbb76f84"
import script from "./ProfilePosts.vue?vue&type=script&lang=js"
export * from "./ProfilePosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports